import { createContext } from 'react';
/* eslint-disable @repo/internal/react/require-jsdoc */
export var ModalContext = /*#__PURE__*/createContext(null);
export var ScrollContext = /*#__PURE__*/createContext(null);